import { queryAccounts, deleteAccount } from './account-data';

export const WAIT_INIT_ACCOUNTS = 'WAIT_INIT_ACCOUNTS';
export const QUERY_ACCOUNTS = 'QUERY_ACCOUNTS';
export const QUERY_ACCOUNTS_SUCCESS = 'QUERY_ACCOUNTS_SUCCESS';
export const QUERY_ACCOUNTS_FAIL = 'QUERY_ACCOUNTS_FAIL';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAIL = 'DELETE_ACCOUNT_FAIL';

export const forwardAccountlList = () => (dispatch) => {
    dispatch({
        type: WAIT_INIT_ACCOUNTS
    });
}

export const queryAccountsData = (idToken, reqBodyObj) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        queryAccounts(resolve, reject, idToken, reqBodyObj);
    });

    doPost
    .then((data) => {
        if ('Success' === data.message) {
            let accounts = data.devices;
            
            dispatch({
                type: QUERY_ACCOUNTS_SUCCESS,
                params: {
                    accounts: accounts
                }
            });
        } else {
            dispatch({
                type: QUERY_ACCOUNTS_FAIL,
                params: {
                    errMsg: data.message
                }
            });
        }        
    }).catch((err) => {
        dispatch({
            type: QUERY_ACCOUNTS_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: QUERY_ACCOUNTS
    });
};

export const removeAccount = (idToken, reqBodyObj, accounts) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteAccount(resolve, reject, idToken, reqBodyObj);
    });

    doPost
    .then((data) => {
        const msg = data.message;
        if (msg === 'Success') {
            let newAccounts = [];
            accounts.forEach(account => {
                if (account.thingName !== reqBodyObj.thingName && account.uid !== reqBodyObj.uid) {
                    newAccounts.push(account);
                }
            });

            dispatch({
                type: DELETE_ACCOUNT_SUCCESS,
                params: {
                    accounts: newAccounts
                }
            });
        } else {
            dispatch({
                type: DELETE_ACCOUNT_FAIL,
                params: {
                    errMsg: msg
                }
            });
        }
    })
    .catch((err) => {
        dispatch({
            type: DELETE_ACCOUNT_FAIL,
            params: {
                errMsg: err.message
            }
        });
    });

    dispatch({
        type: DELETE_ACCOUNT
    });
}